// Gif.js

const Gif = () => (
    <div>
      <div className="tree-image"><img src="/tree.png" alt="tree img" /></div>
    </div>
  );
  
  export default Gif;